var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59497 11.395C6.59497 8.56702 6.59497 7.15202 7.47397 6.27402C8.35197 5.39502 9.76697 5.39502 12.595 5.39502H15.595C18.423 5.39502 19.838 5.39502 20.716 6.27402C21.595 7.15202 21.595 8.56702 21.595 11.395V16.395C21.595 19.223 21.595 20.638 20.716 21.516C19.838 22.395 18.423 22.395 15.595 22.395H12.595C9.76697 22.395 8.35197 22.395 7.47397 21.516C6.59497 20.638 6.59497 19.223 6.59497 16.395V11.395Z",
    stroke: "#4873B8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59497 19.395C5.79932 19.395 5.03626 19.0789 4.47365 18.5163C3.91104 17.9537 3.59497 17.1907 3.59497 16.395V10.395C3.59497 6.62402 3.59497 4.73802 4.76697 3.56702C5.93897 2.39602 7.82397 2.39502 11.595 2.39502H15.595C16.3906 2.39502 17.1537 2.71109 17.7163 3.2737C18.2789 3.83631 18.595 4.59937 18.595 5.39502",
    stroke: "#4873B8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.3528cd3612342ccb69668421369c1d0b.svg";
export { ForwardRef as ReactComponent };